import React from 'react';
import { getBackgroundByShortName, getShortName } from 'Chore/Utils';

const ActivityDetailAvatar = ({ name='', width='size-24', radius='full', avatarUrl = '' }) => {
  const showName = () => {
    return !!avatarUrl?.trim();
  };

  return (showName() ?
    <img alt="failed" className={`w-24 h-24 round-full`} src={avatarUrl} /> :
    <div className={`activity-detail-userinfo-img f-size-12 round-full f-weight-500 v-flex v-items-center v-justify-center v-${getBackgroundByShortName(getShortName(name))}`}>{getShortName(name)}</div>
  );
};

export default ActivityDetailAvatar;
